import { hud } from "./components/hud.js";
import { Screens } from "./components/Screens.js";

document.addEventListener("DOMContentLoaded", e => {
	console.log("App init");

	hud();

	const screens = new Screens(".screens", ".load-screen", ".error-screen");
	screens.add("/", {
		alias: "home",
		renderer: () => {
			return `<h2 class="mt-4">Hello world</h2>`;
		},
		initer: scr => {
			setTimeout(() => scr.ready(), 1000);
			setTimeout(() => scr.error(), 2000);
		}
	});

	screens.add("-", {
		alias: "not-found-screen",
		renderer: () => {
			return `<h2 class="mt-4">404 NOT FOUND</h2>`;
		},
		initer: scr => {
			scr.ready();
		}
	});

	console.log(screens.getScreens());

	screens.routing();
});